import _ from 'lodash'
import { useEffect, useMemo } from 'react'
import { Footer } from '@/components/layout/footer'
import { PageShell } from '@/components/layout/PageShell'
import { CasinoTypeNav } from '@/components/casino/lobby/CasinoTypeNav'
import { CasinoHeroBanners } from '@/components/casino/lobby/CasinoHeroBanners'
import { CasinoLobbyContent } from '@/components/casino/lobby/content/CasinoLobbyContent'
import { CasinoOriginalsContent } from '@/components/casino/lobby/content/CasinoOriginalsContent'
import { CasinoPopularContent } from '@/components/casino/lobby/content/CasinoPopularContent'
import { CasinoProvidersContent } from '@/components/casino/lobby/content/CasinoProvidersContent'
import { CasinoTypeGamesContent } from '@/components/casino/lobby/content/CasinoTypeGamesContent'
import { CASINO_TYPE_LOBBY, CASINO_TYPE_ORIGINALS, CASINO_TYPE_POPULAR, CASINO_TYPE_PROVIDERS } from '@/config/casino'
import { useGetCasinoTypesQuery } from '@/store/api/casinoApi'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { setActiveSection } from '@/store/slices/configSlice'
import { selectSelectedCasinoTypeId, setSelectedCasinoType } from '@/store/slices/casinoSlice'

const SPECIAL_CASINO_TYPES = [CASINO_TYPE_LOBBY, CASINO_TYPE_POPULAR, CASINO_TYPE_ORIGINALS, CASINO_TYPE_PROVIDERS]

export default function Casino() {
	const dispatch = useAppDispatch()
	const storedTypeId = useAppSelector(selectSelectedCasinoTypeId)
	const selectedTypeId = storedTypeId ?? CASINO_TYPE_LOBBY
	const { data: typesResponse } = useGetCasinoTypesQuery()

	useEffect(() => {
		dispatch(setActiveSection('casino'))
	}, [dispatch])

	useEffect(() => {
		if (storedTypeId === null) {
			dispatch(setSelectedCasinoType(CASINO_TYPE_LOBBY))
		}
	}, [dispatch, storedTypeId])

	const selectedTypeName = useMemo(() => {
		if (selectedTypeId === CASINO_TYPE_LOBBY) {
			return 'Lobby'
		}

		if (selectedTypeId === CASINO_TYPE_POPULAR) {
			return 'Popular'
		}

		if (selectedTypeId === CASINO_TYPE_ORIGINALS) {
			return 'Originals'
		}

		if (selectedTypeId === CASINO_TYPE_PROVIDERS) {
			return 'Providers'
		}

		const typeName = _.find(typesResponse?.data, { id: selectedTypeId })?.type_name

		return typeName ? _.capitalize(typeName) : undefined
	}, [selectedTypeId, typesResponse?.data])

	return (
		<PageShell gap='6' footer={<Footer />}>
			<CasinoHeroBanners />
			<CasinoTypeNav />

			{selectedTypeId === CASINO_TYPE_LOBBY ? <CasinoLobbyContent /> : null}
			{selectedTypeId === CASINO_TYPE_POPULAR ? <CasinoPopularContent /> : null}
			{selectedTypeId === CASINO_TYPE_ORIGINALS ? <CasinoOriginalsContent /> : null}
			{selectedTypeId === CASINO_TYPE_PROVIDERS ? <CasinoProvidersContent /> : null}
			{!_.includes(SPECIAL_CASINO_TYPES, selectedTypeId) ? <CasinoTypeGamesContent typeId={selectedTypeId} typeName={selectedTypeName} /> : null}
		</PageShell>
	)
}
